import { CaseUploadWizard } from '../components/CaseUploadWizard';

export function CreateCasePage() {
  return <CaseUploadWizard />;
}